import React from 'react';
import { Td } from '@oforce/global-components';
import { formatElectionServiceDates } from '../../../utils/formatting';

export default function CellCoverageDates({ election }) {
  return <Td className="fs-xs">{formatElectionServiceDates(election)}</Td>;
}
